import { request } from '../utils/request';

export type SchoolHomeDTO = {
	info: any;
	rooms: any[];
	members: any[];
	announcements: any[];
};

export function fetchSchoolHome() {
	return request<SchoolHomeDTO>({
		url: '/admin/vtSchool/pui/home',
		method: 'get',
	});
}

export function fetchSchoolStatistics(params?: { months?: number; topN?: number }) {
	return request<any>({
		url: '/admin/vtSchool/pui/statistics',
		method: 'get',
		params,
	});
}

export function fetchCurrentSchool() {
	return request<any>({
		url: '/admin/vtSchool/pui/current',
		method: 'get',
	});
}

export function fetchMySchoolLabel() {
	return request<{ label: string; inSchool: boolean; schoolId?: number | string }>({
		url: '/admin/vtSchoolStaff/pui/my-school-label',
		method: 'get',
	});
}

export function fetchSchoolWeMeetAccounts() {
	return request<string[]>({
		url: '/admin/vtSchool/pui/manage/wemeet-accounts',
		method: 'get',
	});
}

export function saveSchoolWeMeetAccounts(wemeetAccounts: string[]) {
	return request<boolean>({
		url: '/admin/vtSchool/pui/manage/wemeet-accounts',
		method: 'put',
		data: { wemeetAccounts },
	});
}

export function fetchSchoolRoomsPage(params: Record<string, any>) {
	return request<any>({
		url: '/admin/vtSchool/pui/rooms/page',
		method: 'get',
		params,
	});
}

export function fetchSchoolAnnouncementsPage(params: Record<string, any>) {
	return request<any>({
		url: '/admin/vtRoomAnnouncement/pui/school/page',
		method: 'get',
		params,
	});
}

export function fetchMyRooms() {
	return request<{ manageRooms: any[]; joinedRooms: any[] }>({
		url: '/admin/vtRoomMember/pui/my-rooms',
		method: 'get',
	});
}

export function leaveRoom(roomId: number | string) {
	return request<boolean>({
		url: '/admin/vtRoomMember/pui/leave',
		method: 'post',
		data: { roomId },
	});
}

export function cancelMyJoinApplication(roomId: number | string) {
	return request<boolean>({
		url: '/admin/vtRoomJoinApplication/pui/cancel',
		method: 'post',
		data: { roomId },
	});
}
